import React, { useState, ChangeEvent } from 'react';

import { Row, Column } from 'components/Layout/Grid';
import Text from 'components/Text';

import IconSearch from 'img/search-icon.svg';

import { DateOutputStr } from 'utils/DateOutput';
import { getMaxDateInSearchFilter, getMinDateInSearchFilter } from 'utils/Date';

import { StatusDataIntegrationFilter, StatusErrorSelectedIntegration, TableSearchDataIntegrationProps } from './interface';
import MultiSelect from 'components/MultiSelect';
import PeriodDateToInput from 'components/PeriodDateToInput';

export const TableSearchDashDataIntegration: React.FC<TableSearchDataIntegrationProps> = (props) => {
  const {
    placeholder,
    setCurrentPage,
    setTableFilter
  } = props;

  const randomTableSearchId = `${Math.random() * 1000}`;
  const [searchStr, setSearchStr] = useState('');

  const [period, setPeriod] = useState({
    from: getMinDateInSearchFilter() ?
      DateOutputStr(getMinDateInSearchFilter().toISOString(), 'yyyy-MM-dd') : '',
    to: getMaxDateInSearchFilter() ?
      DateOutputStr(getMaxDateInSearchFilter().toISOString(), 'yyyy-MM-dd') : '',
  });

  const [showSituationDropdown, setShowSituationDropdown] = useState<boolean>(false);

  let selectedSituation: string[] = StatusErrorSelectedIntegration;
  const allStatusDataIntegration = StatusDataIntegrationFilter;

  const makeFilter = () => {
    const newFilter = {
      search: searchStr,
      startPeriod: period.from ? `${period.from}T00:00:00.000Z` : "",
      lastPeriod: period.to ? `${period.to}T23:59:59.999Z` : "",
      status: selectedSituation?.length > 0 ? selectedSituation.toString() : ""
    };

    setCurrentPage(0);
    setTableFilter(newFilter);
  };

  const handleDateFirst = (e: ChangeEvent<HTMLInputElement>) => {
    setPeriod({ ...period, from: e.target.value });
  };

  return (
    <>
      <Row
        id={randomTableSearchId}
        tabIndex={0}
        className="mt-4 align-center flex-md-column align-md-none flex-wrap justify-md-none bg-white px-3 py-3"
        style={{ borderRadius: '10px 10px 0px 0px' }}
      >
        <Column className="mr-2 mr-md-2 w-md-100 ajustment-filter">
          <Text className="mb-1 color-blue-gray" size={12} weight="bold">
            Filtro
          </Text>

          <Row>
            <input
              onChange={(e) => setSearchStr(e.target.value)}
              type="text"
              placeholder={placeholder}
              value={searchStr}
              className="w-md-100 w-number-protocol"
              name="searchStr"
            />
          </Row>
        </Column>

        <Column className="mr-2 mr-md-2 w-md-100 mt-md-3">
          <Text className="mr-2 mb-1 color-blue-gray" size={12} weight="bold">
            Selecione o período de integração
          </Text>
          <Row className="flex-1 align-center grid-gap-2">
            <input
              value={period.from}
              onChange={handleDateFirst}
              type="date"
              max={period.to}
              placeholder="Início"
              id="date_first_data_integration"
              style={{ width: 160 }}
            />
            <PeriodDateToInput
              id={"date_end_data_integration"}
              period={period}
              setPeriod={setPeriod}
              placeHolder={"Fim"}
              style={{ width: 160 }}
            />
          </Row>
        </Column>

        <Column className="mr-2 mr-lg-0 mt-md-3 w-md-100 ajustment-situation">
          <Text className="mr-2 mb-1 color-blue-gray" size={12} weight="bold">
            Situação
          </Text>
          <Row className="flex-1">
            <MultiSelect
              itensSelected={selectedSituation}
              allItems={allStatusDataIntegration}
              width={"200px"}
              className="w-md-100"
              placeHolderOne="situaçao"
              placeHolderMany="situações"
              show={showSituationDropdown}
              setShow={setShowSituationDropdown}
            />

          </Row>
        </Column>

        <Column className="mr-2 mt-md-3 w-md-100 pt-3 pt-md-0 ajustment-button">
          <Row>
            <button
              id="btn_table_search"
              tabIndex={0}
              className="focus-button"
              type='button'
              onClick={() => makeFilter()}
            >
              <img src={IconSearch} alt="" />
            </button>
          </Row>
        </Column>
      </Row>
    </>
  );
};